<template>
</template>

<script type="text">
import { mapGetters } from 'vuex'

export default {
  name: 'HavenLockWidget',
  computed: {
    ...mapGetters({
      lock_devices: 'havenLockDevices'
    }),
    // Creates a lookup table that makes it easy to fetch the status of a lock with a given device_id
    lock_devices_dict: function () {
      let lock_devices_dict = {}
      this.lock_devices.forEach(lock_device => {
        lock_devices_dict[lock_device.device_id] = lock_device
      })
      return lock_devices_dict
   }
  },
  methods: {
    loadLockStatus() {
      this.$store.dispatch('getLockStatus')
    },
    unlockHavenLock (device_id) {
      this.$store.dispatch('commandHavenLock', { 'device_id': device_id, 'command': 'unlock' })
      alert("Unlock command has been sent. It may take a few seconds to appear on the dashboard.")
    },
    lockHavenLock (device_id) {
      this.$store.dispatch('commandHavenLock', { 'device_id': device_id, 'command': 'lock' })
      alert("Lock command has been sent. It may take a few seconds to appear on the dashboard.")
    },
    getLockStatus (device_id) {
      let result = this.lock_devices_dict[device_id]
      if (result) {
        return this.lock_devices_dict[device_id]
      } else {
        return {
            "device_id": -1,
            "device_name": "",
            "status": "Unknown",
            "is_jammed": false,
            "battery_percentage": null
        }
      } 
    },
    getBatteryIcon(device_id) {
      let battery_percent = this.getLockStatus(device_id).battery_percentage
      let fa_battery_icon = null
      let battery_color = "black"

      if (battery_percent === null) {
        return ""
      }

      if (battery_percent >= 90) {
        fa_battery_icon = "fa-battery-full"
      } else if (battery_percent >= 70) {
        fa_battery_icon = "fa-battery-three-quarters"
      } else if (battery_percent >= 45) {
        fa_battery_icon = "fa-battery-half"
      } else if (battery_percent >= 20) {
        fa_battery_icon = "fa-battery-quarter"
      } else if (battery_percent >= 0) {
        fa_battery_icon = "fa-battery-empty"
        if (battery_percent <= 10) {
          battery_color = "red"
        }
      } else {
        return ""
      }

      return "<i style=\"color:" + battery_color + ";\" class=\"fa " + fa_battery_icon + " fa-lg\" aria-hidden=\"true\" title=\"" + battery_percent + "%\"></i>&nbsp;"
    },
    isLocked (device_id, include_unknown = false) {
      return this.getLockStatus(device_id).status === 'Locked' || (include_unknown && this.getLockStatus(device_id).status === 'Unknown')
    },
    isUnlocked (device_id, include_unknown = false) {
      return this.getLockStatus(device_id).status === 'Unlocked' || (include_unknown && this.getLockStatus(device_id).status === 'Unknown')
    },
    isUnknown (device_id) {
      return this.getLockStatus(device_id).status === 'Unknown'
    },
    isJammed (device_id) {
      this.getLockStatus(device_id).is_jammed
    }
  },
  created () {
    this.loadLockStatus()
  },
  mounted () {
    setInterval(() => {
      this.loadLockStatus()
    }, 8000)
  },
  beforeDestroy () {
    clearInterval(this.interval);
  }
}
</script>